import Skeleton from '@/common/components/skeleton/Skeleton';
import { DiscoverCardSkeletonInfo } from '../discoverSkeleton/discoverSkeleton.styles';
import { DiscoverFeedCardSkeletonRoot } from './discoverFeedCardSkeleton.styles';

const DiscoverFeedCardSkeleton = () => (
	<DiscoverFeedCardSkeletonRoot data-discover-skeleton="true" aria-hidden="true">
		<Skeleton
			width="100%"
			height="100%"
			radius="0"
			minWidth="100%"
			minHeight="100%"
		/>
		<DiscoverCardSkeletonInfo>
			<Skeleton width="46%" height="28px" radius="8px" minHeight="28px" />
			<Skeleton width="88%" height="14px" radius="6px" minHeight="14px" />
			<Skeleton width="72%" height="14px" radius="6px" minHeight="14px" />
			<Skeleton width="148px" height="42px" radius="999px" minHeight="42px" />
		</DiscoverCardSkeletonInfo>
	</DiscoverFeedCardSkeletonRoot>
);

export default DiscoverFeedCardSkeleton;
